export const environment = {
  production: true,
  MEDTECH_API: 'https://api.app.qualio.com',
  APP_URL: 'https://app.document-templates.qualio.com',
  environmentName: 'production',
  loginUrl: 'https://app.qualio.com/login',
  authSuccessRefreshIntervalMillis: 60000,
  authErrorRetryIntervalMillis: 5000,
  LOG_LEVEL: 'debug',
  redirect_to_login_on_jwt_failure: true,
  launchDarklyClientKey: '61e6a31060139c1610d1516c',
  GLOBAL_SEARCH_SERVICE_URL: 'https://global-search.app.qualio.com',
  QRI_SERVICE_URL: 'https://qri.app.qualio.com',
};
